"use client";

import { Check, Copy } from "geist-icons";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

type CopyButtonProps = {
  text: string;
  className?: string;
};

export default function CopyButton({ text, className }: CopyButtonProps) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text);

    setIsCopied(true);
  };

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    }
  }, [isCopied]);

  return (
    <button
      className={`transition p-1 hover:bg-[#EAEAEA] dark:hover:bg-[#1E1E1E] rounded-full cursor-pointer ${className}`}
      onClick={handleCopy}
    >
      {isCopied ? (
        <motion.div
          key="check"
          initial={{ scale: 0.1, opacity: 1 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.1, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <Check className={`flex scale-75 cursor-pointer ${className}`} />
        </motion.div>
      ) : (
        <motion.div
          key="copy"
          initial={{ scale: 0.1, opacity: 1 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.1, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <Copy className={`flex scale-75 cursor-pointer ${className}`} />
        </motion.div>
      )}
    </button>
  );
}
